import { ApiError } from '../lib/api';

export interface PoolPageErrorState {
  kind: 'not_found' | 'error';
  title: string;
  description: string;
}

interface ClassifyInput {
  hasPool: boolean;
  error: unknown;
}

export function classifyPoolPageErrorState(input: ClassifyInput): PoolPageErrorState | null {
  if (!input.error && input.hasPool) {
    return null;
  }

  if (input.error instanceof ApiError && input.error.status === 404) {
    return {
      kind: 'not_found',
      title: 'Bolão não encontrado',
      description: 'Esse bolão não existe ou não está mais disponível.',
    };
  }

  if (!input.hasPool && !input.error) {
    return {
      kind: 'not_found',
      title: 'Bolão não encontrado',
      description: 'Esse bolão não existe ou não está mais disponível.',
    };
  }

  return {
    kind: 'error',
    title: 'Erro ao carregar bolão',
    description: 'Não foi possível carregar os dados do bolão agora. Tente novamente em instantes.',
  };
}
